import Megatron, { get, megatronPostServerSide }  from '../../../../utils/megatron/megatron';
import { 
  smartEngageapi, 
  calendarapi, 
  pagemakerapi,
  QUERY_FORM_DATA_API, 
  hrPackageApi,
  fetchLocationDetails,
  pokusApi
}                               from '../../../shared/config/constants';
import { 
  ThunkAction, 
  ThunkDispatch 
}                               from 'redux-thunk';
import { AppState }             from './../../../store';
import { AnyAction }            from 'redux';
import { 
  AT_MODAL_DETAILS, 
  DEFAULT_HR_PACKAGE, 
  DEFAULT_HR_PACKAGE_TIME, 
  HR_PACKAGE_DETAILS, 
  OS_MODAL_DETAILS, 
  UPDATE_HR_PACKAGE,
  UPDATE_HR_PACKAGE_TIME
}                                 from '../../pages/SearchPage/redux/action-types';
import { getCookie, setAllPackageIdsForRental } from '../../config/utils';
import megatron from '../../../../utils/megatron/megatron';
import { getAddress } from '../../../shared/pages/HouseOfBrands/utils';

const prepareHolidayCalendarApiRequest = () => {
  return `${__ENV_CONFIG__['__VOYAGER__']}${calendarapi}`;
};

export async function getHolidayCalendarApi() {
  const url = prepareHolidayCalendarApiRequest();
  const response = await Megatron({
    name: 'Fetch Cabs Holiday Calendar',
    type: 'GET',
    url,
    credentials: 'same-origin',
  });
  return response;
}

export default getHolidayCalendarApi;

const prepareCurrentLocationApiRequest = ({ latitude, longitude }) => {
  return `${__ENV_CONFIG__['__GOCARS__']}/v1/places/locate?latitude=${latitude}&longitude=${longitude}`;
}

export async function getCurrentLocationApi({ latitude, longitude }) {
  const headers = {Authorization: "Basic Zm9vOmJhcg==" };
  const url = prepareCurrentLocationApiRequest({ latitude, longitude });
  const response = await Megatron({
    name: 'Fetch Location api',
    type: 'GET',
    url,
    credentials: 'same-origin',
    headers
  });
  return response?.response || {};
}

export const fetchGotribe = ({slot, page}): ThunkAction<
  void,
  AppState,
  {},
  AnyAction
> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    const url = `${__ENV_CONFIG__['__VOYAGER__']}${smartEngageapi}&slots=["${slot}"]&lob=cab&page=${page}`;
    const response = await Megatron({
      name: 'Fetch gotribe api',
      type: 'GET',
      url,
      credentials: 'include'
    });
    switch (page) {
      case 'srp': 
        dispatch({
          type: 'UPDATE_SMARTENGAGE_BANNER',
          smartengage: {
            [slot]: response?.data?.slots?.[slot] || []
          }
        });
        break;
      default: 
        dispatch({
          type: "UPDATE_GOTRIBE",
          gotribe: {
            [slot]: response?.data?.slots?.[slot] || []
          }
        });
        break;
    }
  }
}

export const fetchPageMakerAPIs = ({isTemplates}): ThunkAction<
  void,
  AppState,
  {},
  AnyAction
> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    const url = `${__ENV_CONFIG__['__VOYAGER__']}${pagemakerapi}["${isTemplates}"]`;
    try {
      const response = await Megatron({
        name: 'carsResultsPagePagemaker',
        type: 'GET',
        credentials: 'same-origin',
        url,
      });
      const resp = {
        [isTemplates]: response?.data?.[isTemplates]?.template || {}
      };
      dispatch({
        type: 'UPDATE_PAGEMAKER_RESPONSE',
        pageMakerResponse: resp
      });
    } catch (err) {
      console.info("err", err);
    }
  };
};

export const fetchPageMakerAPIServer = async ({ isTemplates }) => {
    const url = `${__ENV_CONFIG__['__VOYAGER__']}${pagemakerapi}["${isTemplates}"]`;
    try {
      const response = await get(url, {
        name: 'carsResultsPagePagemaker',
      });
      const resp = {
        [isTemplates]: response?.data?.data?.[isTemplates]?.template || {}
      };
      return resp;
    } catch (err) {
      console.log("err", err);
      return null;
    }
};

export const fetchCabsFaqData = async () => {
  const url = `${__ENV_CONFIG__['__VOYAGER__']}${pagemakerapi}["cabs_faq_data"]`;
  try {
    const response = await Megatron({
      name: 'carsResultsPagePagemaker',
      type: 'GET',
      credentials: 'same-origin',
      url
    });
    return response?.data?.cabs_faq_data?.template || []
  } catch (err) {
    console.log("err", err);
    return null;
  }
}

export const fetchQueryFormData = (): ThunkAction<
  void,
  AppState,
  {},
  AnyAction
> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
	) => {

    const url = `${__ENV_CONFIG__['__GOCARS__']}${QUERY_FORM_DATA_API}`;
    try {
      const response = await Megatron({
        name: 'cars_queery_field',
        type: 'GET',
        url,
      });
     
      dispatch({
        type: "UPDATE_QUERY_FIELDS_DATA",
        queryFields:response
       
      });
    } catch (err) {
      console.info("err", err);
    }
  };
};

export const fetchModalInfoAndPackageDetails = (): ThunkAction<
  void,
  AppState,
  {},
  AnyAction
> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    const url = `${__ENV_CONFIG__['__VOYAGER__']}${hrPackageApi}`;
    try {
      const respJson : any = await Megatron({
        name: 'cars_modal',
        type: 'GET',
        credentials: 'same-origin',
        url,
      });

      const packages = respJson?.data?.cabs_rental?.template?.packages || []

      const hrResponse = {
        packages            : packages, 
        rentalModalDetails  : respJson?.data?.cabs_rental?.template?.rentalBottomSheetData || {}
      }

      const osModalResponse = {
        osModalData : respJson?.data?.cabs_rental?.template?.osBottomSheetData || {}
      }

      const atModalResponse = {
        airportModalData : respJson?.data?.cabs_rental?.template?.airportBottomSheetData || {},
      }

      const { common = {} } = getState()
      const { package_id } = common

      if (packages?.length && !package_id?.length) {
        dispatch({
          type        : UPDATE_HR_PACKAGE,
          package_id  : packages[0]?.name || ""
        })
        dispatch({
          type        : UPDATE_HR_PACKAGE_TIME,
          packageTime : packages[0]?.time || ""
        })
      }

      dispatch({
        type: DEFAULT_HR_PACKAGE,
        defaultPackageId: packages[0]?.name || ""
      })
      dispatch({
        type: DEFAULT_HR_PACKAGE_TIME,
        defaultPackageTime: packages[0]?.time || ""
      })
      
      dispatch({
        type              : HR_PACKAGE_DETAILS,
        hrPackageDetails  : hrResponse || {}
      })

      dispatch({
        type            : OS_MODAL_DETAILS,
        osModalDetails  : osModalResponse || {}
      })

      dispatch({
        type            : AT_MODAL_DETAILS,
        atModalDetails  : atModalResponse || {}
      })

      setAllPackageIdsForRental(hrResponse?.packages)

    } catch (err) {
      console.info("err", err);
    }
  };
};

export const getPlaceDetails = async (placeId) => {
  const url = `${__ENV_CONFIG__['__GOCARS__']}${fetchLocationDetails}=${placeId}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    "content-type": "application/json"
  };

  try {
    const response = await megatron({
      name: "cars place details",
      type: "GET",
      credentials: 'include',
      url,
      headers
    });
  const results = response?.results || [];
    const [result] = results
    return getAddress(result);
  } catch (err) {
    console.info("err", err);
    return {}
  }
};

export const getPokusDetails = async (cookieString?: string) => {
  let deviceId = "";
  let oAuthToken = "";
  // If cookie string is provided (server-side), parse it to get device ID
  if (cookieString) {
    const cookies = cookieString.split(';').reduce((acc, cookie) => {
      const [key, value] = cookie.trim().split('=');
      acc[key] = value;
      return acc;
    }, {} as Record<string, string>);
    deviceId = cookies['__gi_vid'] || "";
    oAuthToken = cookies['OAUTH-GOIBIBO'] || "";
  } else if (typeof document !== 'undefined') {
    // Only use document.cookie if we're in the browser
    deviceId = await getCookie('__gi_vid') || "";
    oAuthToken = await getCookie('OAUTH-GOIBIBO') || "";
  }
  
  const url = `${__ENV_CONFIG__['__POKUS__']}${pokusApi}`;
  
  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    "content-type": "application/json",
    region: 'IN',
    language: 'EN',
    'OAUTH-GOIBIBO': oAuthToken
  };

  const requestBody = {
    lob: "CAB",
    user: {
      deviceId: deviceId
    },
    attributes: {
      device_os: "desktop",
      device_type: "desktop"
    },
    scope: {
      lob: "CAB",
      deviceOS: "DESKTOP",
      tags: []
    }
  };

  try {
    const megatronOptions = {
      name: 'Fetch Pokus Details',
      type: 'POST' as const,
      url,
      credentials: 'omit',
      requestData: JSON.stringify(requestBody),
      headers
    };

    const response = cookieString 
      ? await megatronPostServerSide(megatronOptions)
      : await Megatron(megatronOptions);

    return response?.configs || {}
  } catch (err) {
    console.error("Error fetching Pokus details:", err);
    return {}
  }
};
